const inventoryFormStyles = (theme) => ({
  variantSection: {
    px: "0px !important",
    width: "unset !important",
  },
  formWrap: {
    background: "white",
  },
  updateFormWrap: {
    width: { xs: "100%", sm: "60%", md: "50%" },
    padding: { xs: "0px", sm: "20px" },
    background: { xs: "none", sm: "white" },
    margin: { xs: "0px auto", sm: "0px auto" },
    position: "relative",
    top: { xs: "0px", sm: "24px" },
  },
  headerWrap: {
    // Empty wrapper for non-update form
  },
  header: {
    fontFamily: "Lexend",
    fontSize: "24px",
    fontWeight: 400,
    lineHeight: "30px",
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
  inventoryFormWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    marginTop: "20px",
  },
  subHeading: {
    fontFamily: "Lexend",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "25px",
    color: theme?.palette?.primary?.main || "#0F0F0F",
    marginBottom: "10px",
  },
  productInformationTextfields: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  doubleTextfields: {
    display: "flex",
    gap: "20px",
    flexDirection: { xs: "column", sm: "row" },
  },
  textFields: {
    width: "100%",
  },
  variants: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  addVariantBtn: {
    display: "flex",
    justifyContent: "flex-end",
  },
  variantBtn: {
    border: `1.2px solid ${theme?.palette?.primary?.main || "#0F0F0F"}`,
    fontFamily: "Lexend",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "17.5px",
    borderRadius: "0px",
    height: "32px",
  },
  updateHeaderWrap: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  productCloseWrap: {
    display: "flex",
    gap: "1px",
    alignItems: "center",
    cursor: "pointer",
  },
  productCloseText: {
    fontFamily: "Lexend",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "20px",
    color: theme?.palette?.customColor?.red || "#B60218",
  },
  productCloseIcon: {
    fontSize: "20px",
    color: theme?.palette?.customColor?.red || "#B60218",
  },
  submitBtn: {
    marginTop: "20px",
    width: "100%",
    padding: "9px",
    fontSize: "16px",
    fontWeight: 400,
    textTransform: "none",
    borderRadius: "0px",
  },
});

export default inventoryFormStyles;

